














helpers = require('../../../helpers.coffee')

view_model = {
  components:
    list: require('./list')

  props: ['users_options']

  data: ->
    user_filter: null

  methods:
    reloadTasks: ->
      @$nextTick =>
        @$refs.done_tasks_list.reloadTasks()

  computed:
    show_user_filter: ->
      !Session.current_user.isSeller()

    done_today_filters: ->
      filters = {}
      filters.done = true
      if Session.current_user.isSeller()
        filters.assigned_to_id_eq = Session.current_user.id
      else
        filters = Object.assign({}, filters, @user_filter || {})
        filters.assigned_to_id_eq = @user_filter.user_id_eq if @user_filter
      filters.done_at_gteq = @start_of_day
      filters.done_at_lteq = @end_of_day
      filters.s = ['done_at desc']
      filters

  created: ->
    @current_user = Session.current_user
    @tasks_resources = new TasksResource
    @end_of_day = moment().endOf('day').toJSON().replace('Z', '') + '999Z'
    @start_of_day = moment().startOf('day').toJSON()

}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/done_tasks/done_tasks_feed.vue